import { GfsAssessmentListPage } from "@/services/backend/gfs/assessment/components/assessment-list-page";

export default function GfsAssessmentsRoute() {
  return <GfsAssessmentListPage />;
}
